import React, { useState, useEffect } from 'react'
import { Alert, Typography } from '@mui/material';
import { Modal, Accordion } from 'react-bootstrap'
import UpdateForm from './UpdateForm'
import './BusinessHours.css'
import { readSessionUser } from '../accountAccess'

export default function WorkingHours() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState(null);
  const [accessError, setAccessError] = useState('');

//API call
  useEffect(() => {
    const { user, error } = readSessionUser();

    if (error) {
      setAccessError(error);
      setAccessType(null);
      return;
    }

    const resolvedAccess = user.role_capabilities?.all_modules_access === true
      ? 'Edit'
      : user.access?.['BusinessHours_Access Specifier'];

    if (resolvedAccess !== 'Edit' && resolvedAccess !== 'View') {
      setAccessError('Your role does not have access to the Business Hours module.');
      setAccessType(null);
      return;
    }

    setAccessError('');
    setAccessType(resolvedAccess);
  }, []);


  return (
    <div className="business-hours-page">

        <div className="business-hours-header">
          <div className="business-hours-header-title">
            <Typography className="business-hours-title" variant='h4'>
              Business Hours {accessType === 'View' ? " / View Only Mode" : ""}
            </Typography>
          </div>
          <div className="business-hours-header-actions">

            <button type="button" className="btn btn-danger business-hours-help-button" onClick={() => setLgShow(true)}>Help</button>
            <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="example-modal-sizes-title-lg"
              dialogClassName="business-hours-help-modal"

            >
              <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                <Modal.Title id="example-modal-sizes-title-lg" >
                  Instructions to Add/Edit Business Hours
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                <style>{`
                  .help-badge {
                    padding: 4px 10px;
                    border-radius: 16px;
                    font-weight: 700;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-right: 10px;
                  }
                  .badge-create  { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                  .badge-holiday { background: #ebf8ff; color: #2b6cb0; border: 1px solid #bee3f8; }
                  .badge-update  { background: #fffaf0; color: #9c4221; border: 1px solid #feebc8; }
                  .badge-delete  { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }
                  
                  .help-card-text {
                    font-size: 14px;
                    color: #4a5568;
                    line-height: 1.5;
                    margin-bottom: 16px;
                  }
                  .video-responsive-wrapper {
                    position: relative;
                    width: 100%;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                    border-radius: 8px;
                    overflow: hidden;
                    background: #000000;
                  }
                  .video-responsive-wrapper video {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                  .accordion-button:not(.collapsed) {
                    background-color: #f1f5f9;
                    color: #1e293b;
                  }
                `}</style>

                <Accordion defaultActiveKey="0" flush>

                  {/* 1. CREATE BUSINESS HOURS */}
                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-create">Create</span>
                      <strong>How to Create Business Hours</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the <strong>Account Name</strong> and <strong>Location Name(s)</strong> from the dropdown, then select the <strong>Type</strong>, <strong>From Date</strong>, <strong>To Date</strong>, and enter the business hours. For Long Weekends/Holidays, select the date, enter the opening and closing times, and click <strong>Add</strong>. A confirmation message will be displayed once the holiday hours are added successfully.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Bussiness - create.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 2. LONG WEEKEND / HOLIDAY */}
                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-holiday">Holiday / Weekend</span>
                      <strong>How to Set Long Weekend / Holiday Timings</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Long weekend timings or holiday schedules can be entered on a date basis in the dedicated section located on the right side of the page.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Business - long.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 3. UPDATE BUSINESS HOURS */}
                  <Accordion.Item eventKey="2" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-update">Update</span>
                      <strong>How to View or Edit Business Hours</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the <strong>Account Name</strong> from the dropdown to view the existing location details. Select the required location to view, edit, or delete it. After making changes, click the <strong>Submit</strong> button to save the updates.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Business - edit.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  {/* 4. DELETE BUSINESS HOURS */}
                  <Accordion.Item eventKey="3" className="mb-2 border rounded">
                    <Accordion.Header>
                      <span className="help-badge badge-delete">Delete</span>
                      <strong>How to Delete Business Hours</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="help-card-text">
                        Select the required account and location, then click the <strong>Delete icon</strong> for the desired operation hours in the table. A confirmation pop-up will display indicating that the action will permanently delete the entry.
                      </p>
                      <div className="video-responsive-wrapper">
                        <video controls preload="metadata" playsInline>
                          <source src="https://d1efa1i7wh44gq.cloudfront.net/Business - delete.mp4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                </Accordion>
              </Modal.Body>
            </Modal>

          </div>
        </div>

      {accessError && (
        <div className="business-hours-access-message">
          <Alert severity="error">{accessError}</Alert>
        </div>
      )}
      {!accessError && accessType === null && (
        <div className="business-hours-access-message">
          <Alert severity="info">Loading Business Hours access...</Alert>
        </div>
      )}
      {!accessError && accessType && <UpdateForm accessType={accessType} />}



    </div>
  );
}
